<h5 class="filter-title">{{ labels.TITLE }}</h5>
<div class="options-container">
  <div class="options-container">
    <app-autocomplete-dropdown
      class="filter-option"
      [options]="avaliableTags"
      [displayWith]="displayTagFn"
      (selectionChange)="onTagSelectionChange($event)"
    >
      <ng-template>
        <i
          tabindex="0"
          class="fas fa-circle-plus add-filter"
          (click)="addIncludeFilterTag()"
        ></i>
        <i
          tabindex="0"
          class="fas fa-circle-minus add-filter"
          (click)="addExcludeFilterTag()"
        ></i>
      </ng-template>
    </app-autocomplete-dropdown>
  </div>
  <div class="tags-container">
    <div class="filter-tag include" *ngFor="let tag of includeTags">
      {{ tag.name }}
      <i
        tabindex="0"
        class="fas fa-circle-xmark remove-icon"
        (click)="removeIncludeFilterTag(tag)"
      ></i>
    </div>
    <div class="filter-tag exclude" *ngFor="let tag of excludeTags">
      {{ tag.name }}
      <i
        tabindex="0"
        class="fas fa-circle-xmark remove-icon"
        (click)="removeExcludeFilterTag(tag)"
      ></i>
    </div>
  </div>
</div>
